var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactjs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "react-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#3498db",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "reactjs",
    transform: "translate(262.312 -536.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(-245.233 554.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M-226.733,570.08c-.234-.07-.445-.141-.68-.211a3.321,3.321,0,0,0,.094-.469c.516-2.508.188-4.523-.961-5.179-1.1-.633-2.906.023-4.734,1.617-.187.164-.352.328-.516.492-.117-.117-.234-.211-.352-.328-1.9-1.687-3.82-2.414-4.969-1.734-1.1.633-1.43,2.531-.961,4.9.047.234.094.469.164.7a5.969,5.969,0,0,0-.773.258c-2.25.773-3.68,2.016-3.68,3.281,0,1.312,1.523,2.625,3.867,3.422.188.07.375.117.562.188-.07.258-.117.492-.164.75-.445,2.32-.094,4.172,1.008,4.8,1.125.656,3.047-.023,4.9-1.641.141-.117.3-.258.445-.4.187.188.375.352.562.516,1.8,1.547,3.562,2.18,4.664,1.547,1.125-.656,1.5-2.648,1.031-5.062-.047-.188-.07-.375-.117-.562.141-.047.258-.07.4-.117,2.414-.8,4.008-2.109,4.008-3.422-.023-1.336-1.5-2.578-3.8-3.351Z",
    transform: "translate(244.241 -562.059)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M-203.184,592.3a2.015,2.015,0,0,1,2.016,2.016,2.015,2.015,0,0,1-2.016,2.016,2.015,2.015,0,0,1-2.016-2.016,2,2,0,0,1,2.016-2.016",
    transform: "translate(214.457 -583.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 11.179,
    cy: 4.57,
    rx: 11.179,
    ry: 4.57,
    transform: "translate(0 6.029)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(3.805 0.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M-216.613,577.07c-2.578,0-6.234-3.187-8.976-8.062a22.61,22.61,0,0,1-2.789-7.757c-.3-2.508.211-4.312,1.5-5.016,2.531-1.43,7.031,1.969,10.265,7.734s3.8,11.367,1.289,12.8h0A2.9,2.9,0,0,1-216.613,577.07Zm-8.929-20.015a1.248,1.248,0,0,0-.727.188c-.82.469-1.172,1.875-.914,3.867a21.018,21.018,0,0,0,2.648,7.336c3.07,5.437,7.031,8.2,8.672,7.289h0c1.641-.914,1.336-5.742-1.734-11.2C-220.293,559.774-223.644,557.055-225.542,557.055Z",
    transform: "translate(228.463 -555.909)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(3.832 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M-225.478,576.968a2.458,2.458,0,0,1-1.289-.328h0c-2.531-1.43-1.969-7.031,1.289-12.8a22.3,22.3,0,0,1,5.2-6.422c1.992-1.57,3.8-2.039,5.086-1.312,2.531,1.43,1.969,7.031-1.289,12.8C-219.244,573.78-222.9,576.968-225.478,576.968Zm-.727-1.336c1.641.914,5.6-1.852,8.672-7.289s3.375-10.265,1.734-11.2c-.82-.469-2.2-.023-3.773,1.219a20.925,20.925,0,0,0-4.9,6.07c-3.07,5.437-3.375,10.265-1.734,11.2Z",
    transform: "translate(228.349 -555.775)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjs);
export default __webpack_public_path__ + "static/media/reactjs.e6289a6e8392550d221c3bc93c82ddf1.svg";
export { ForwardRef as ReactComponent };